// extracted by mini-css-extract-plugin
export default {"root":"_2hAqi","top":"_35QUb","bottom":"_2mOqv","left":"wFBOU","middle":"_1crj-","indicators":"_2boWc","right":"_2aZbZ","engagement":"_1biTS"};